import React from 'react';
import { Dropdown } from 'v1/components/shared';
import _filter from 'lodash/filter';
import { useRestrictedAccessCallback } from 'lib/restrictedAccess/useRestrictedAccess';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger
} from '../../../../../v5/design-system/DropdownMenu.js';

// This dropdown and dropdown item is a workaround until https://github.com/reach/reach-ui/issues/23 is fixed

/**
 * @deprecated use RestrictedDropdown (.connected version) instead
 */
export default ({ children, capabilitiesAtLeastOne, showLabel, ...rest }) => {
  const testRestrictedAccess = useRestrictedAccessCallback();
  const menuNotEmpty = testRestrictedAccess(null, null, capabilitiesAtLeastOne);

  if (!menuNotEmpty && !showLabel) {
    return null;
  }

  if (!Array.isArray(children)) {
    children = [children];
  }
  children = _filter(children, c => c != null && c !== false);

  const items = _filter(children, child => {
    if (!child) {
      return false;
    }
    return testRestrictedAccess(
      null,
      child.props && child.props.capabilities, // TODO
      null
    );
  });

  return (
    <Dropdown disabled={!menuNotEmpty && showLabel} {...rest}>
      {items}
    </Dropdown>
  );
};

export function RestrictedDropdownV5({
  children,
  trigger,
  capabilitiesAtLeastOne,
  showLabel,
  side = 'bottom',
  align = 'center',
  disabled,
  ...rest
}) {
  const testRestrictedAccess = useRestrictedAccessCallback();
  const menuNotEmpty = testRestrictedAccess(null, null, capabilitiesAtLeastOne);

  if (!menuNotEmpty && !showLabel) {
    return null;
  }

  if (!Array.isArray(children)) {
    children = [children];
  }
  children = _filter(children, c => c != null && c !== false);

  const items = _filter(children, child => {
    if (!child) {
      return false;
    }
    return testRestrictedAccess(
      null,
      child.props && child.props.capabilities, // TODO
      null
    );
  });

  return (
    <DropdownMenu {...rest}>
      <DropdownMenuTrigger
        asChild
        disabled={disabled || (!menuNotEmpty && showLabel)}
      >
        {trigger}
      </DropdownMenuTrigger>
      <DropdownMenuContent side={side} align={align}>
        {items}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

/**
 * Use it directly inside a RestrictedDropdown
 *
 */
export function RestrictedDropdownItem({ children, capabilities }) {
  return children;
}
